// Module
var code = `<div class="late-project-submission-box"><p class="submit-projects-message" translate="lessons.stream.student_dashboard_boxes.submit_projects_in_case" translate-values="{num: pastDueProjects.length}" translate-interpolation="messageformat"></p><past-due-projects-list past-due-projects="pastDueProjects"></past-due-projects-list></div>`;
// Exports
export default code;